import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Card from '@/modules/common/components/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import { formatDate } from '~/common';
import { withFetch } from '~/hocs/fetch';
import Form from './Form';
import '../../styles/PostBacks/PostBacks.scss';
import {useSnackbar} from "notistack";

const initialValues = {
    date: {from: null, to: null},
    offers: [],
    affiliates: [],
}

let abortController;

const PostBacks = (props) => {
    const [fetching, setFetching] = useState(false);
    const [values, setValues] = useState(initialValues);

    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        if (abortController) {
            abortController.abort();
        }
    }, []);

    const handleSubmit = (event) => {
        abortController = new AbortController();
        setFetching(true);
        event.preventDefault();
        props.fetch.post(
            '/api/cfg/postbacks/resend/', {
                date_from: formatDate(values.date.from),
                date_to: formatDate(values.date.to),
                offers: values.offers,
                affiliates: values.affiliates,
            }, abortController
        ).then(({ok, data}) => {
            if (ok) {
                enqueueSnackbar('Процесс запущен', {variant: 'success'});
                setValues(initialValues);
            }
            setFetching(false);
        }).catch((error) => {
            if (error.name !== 'AbortError') {
                setFetching(false);
            }
        }).finally(() => {
            abortController = null;
        });
    }

    return (
        <Card>
            <CardHeader title="Переотправка PostBack'ов"></CardHeader>
            <CardContent>
                <Form values={values} setValues={setValues} onSubmit={handleSubmit} disabled={fetching}/>
            </CardContent>
        </Card>
    )
}

let Component = PostBacks;
Component = withFetch(Component);

export default connect(
    (state) => ({
        affiliates: state.affiliates,
    }),
    null,
)(Component);
